import { QueryClient, type Query } from '@tanstack/react-query';

// While the content API is failing, keep retrying in the background (15s, 30s, 60s, then every 2 min)
// so the page heals itself without a reload. Reconnecting to the internet refetches immediately.
const AUTO_RETRY_DELAYS_MS = [15_000, 30_000, 60_000, 120_000];

function retryWhileFailing(query: Query): number | false {
  if (query.state.status !== 'error') return false;
  const failures = Math.max(query.state.errorUpdateCount, 1);
  return AUTO_RETRY_DELAYS_MS[Math.min(failures - 1, AUTO_RETRY_DELAYS_MS.length - 1)];
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Blog posts don't change frequently; list/detail hooks override this with a shorter time
      staleTime: 10 * 60 * 1000,
      // Keep unused data for instant navigation back to previously viewed content
      gcTime: 30 * 60 * 1000,

      // The API client already retries each request; this adds a couple of slower retries
      retry: 2,
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 10000),
      refetchInterval: retryWhileFailing,

      refetchOnWindowFocus: true,
      refetchOnMount: true,
      refetchOnReconnect: true,
      networkMode: 'offlineFirst',
    },
  },
});
